export function baiduMap(ak) {
    return new Promise(function (resolve, reject) {
      if (typeof window.BMap !== "undefined") {
        resolve(window.BMap);
        return true;
      }
      window.onBMapCallback = function () {
        resolve(window.BMap);
        return true;
      };
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "http://api.map.baidu.com/api?v=2.0&ak=" + ak + "&callback=onBMapCallback";
      script.onerror = reject;
      document.head.appendChild(script);
      return true;
    })
  }


// WEBPACK FOOTER //
// ./src/assets/js/baiduMap.js